export type LinkSection = "featured" | "explore" | "gear" | "work";

export type LinkItem = {
  id: string;
  section: LinkSection;
  label: string;
  sublabel: string;
  href: string;
  icon: "book" | "cart" | "map" | "camera" | "package" | "tag" | "briefcase" | "users" | "mail" | "youtube";
};

export type SiteContent = {
  siteTitle: string;
  metaDescription: string;
  heroImage: string;
  heroTitle: string;
  heroTagline: string;
  currentLocation: string;
  intro: string;
  newsletterTitle: string;
  newsletterDescription: string;
  contactEmail: string;
  links: LinkItem[];
};

export const defaultContent: SiteContent = {
  siteTitle: "The Eternal Roadtrip Links",
  metaDescription: "Sophia and Lucas, full-time RV life in a 42 ft fifth wheel with two cats. The reality, the budgets, the chaos, and the gear that we actually use.",
  heroImage: "/assets/hero-mountain.jpeg",
  heroTitle: "The Eternal Roadtrip",
  heroTagline: "Sophia & Lucas, full-time in a 42 ft Brinkley 5th wheel with two cats, Luna & Kora.",
  currentLocation: "⛰️ Currently in California",
  intro: "The blog, the gear we actually use, and a new video every week. Everything from the road, in one place.",
  newsletterTitle: "Don't Miss a Mile",
  newsletterDescription: "Trip updates, gear picks, and honest stories from life on the road. No spam, ever.",
  contactEmail: "hello@theeternalroadtrip.com",
  links: [
    { id: "blog", section: "featured", label: "Read the Blog", sublabel: "Stories from the road", href: "https://theeternalroadtrip.com/blog", icon: "book" },
    { id: "gear", section: "featured", label: "Shop Our RV & Outdoor Gear", sublabel: "Everything we actually use, on our Amazon storefront", href: "https://a.co/d/0fYQDnUR", icon: "cart" },
    { id: "youtube", section: "featured", label: "Watch on YouTube", sublabel: "New episodes every week", href: "https://www.youtube.com/@theeternalroadtrip", icon: "youtube" },
    { id: "start-here", section: "explore", label: "New here? Start Here", sublabel: "Meet us and see how it all began", href: "https://theeternalroadtrip.com/about", icon: "camera" },
    { id: "map", section: "explore", label: "Our Travel Map", sublabel: "Every place we've parked and explored", href: "https://theeternalroadtrip.com/map", icon: "map" },
    { id: "story", section: "explore", label: "Our Story", sublabel: "How we got here, and why we never want to leave", href: "https://theeternalroadtrip.com/about", icon: "camera" },
    { id: "optics", section: "gear", label: "Good Day Optics Ambassador", sublabel: "Use code ETERNALROADTRIP for 15% off", href: "https://gooddayoptics.com", icon: "tag" },
    { id: "portfolio", section: "work", label: "Brand Partnership Portfolio", sublabel: "UGC, ambassador deals, brand integrations & more", href: "https://eternalroadtripportfolio.co", icon: "briefcase" },
    { id: "partner", section: "work", label: "Partner With Us", sublabel: "Get in touch about collaborations", href: "https://eternalroadtripportfolio.co/contact", icon: "users" },
    { id: "email", section: "work", label: "hello@theeternalroadtrip.com", sublabel: "Direct email for inquiries", href: "mailto:hello@theeternalroadtrip.com", icon: "mail" }
  ]
};

export function withContactEmail(content: SiteContent, contactEmail: string): SiteContent {
  return {
    ...content,
    contactEmail,
    links: content.links.map((link) =>
      link.id === "email"
        ? { ...link, label: contactEmail, href: `mailto:${contactEmail}` }
        : link,
    ),
  };
}
